import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "../App.css";

import { ChevronRightIcon } from "@radix-ui/react-icons";

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../components/ui/table";
import api from "../lib/api";
import { Skeleton } from "./ui/skeleton";

function BunnyChildren({ bunny }) {
    const [fetchedChildren, setFetchedChildren] = useState(null);
    const [error, setError] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const fetchChildren = async () => {
        // Fetch children
        api.get(`https://skhrf-api.cmdigital.se/v1/bunnies/children?bunnyId=${bunny.id}`)
            .then(response => {
                ;
                setFetchedChildren(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Error fetching children:', error);
                setFetchedChildren(null);
                setError(error);
                setIsLoading(false);
            });
    }

    useEffect(() => {
        fetchChildren();
    }, [bunny]);

    return (
        <div className='rounded-md bg-gray-100 p-3'>
            {isLoading ? (
            <Skeleton className='h-10 w-full' />
            ) : (
            <div className='rounded-md border bg-white'>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Namn</TableHead>
                            <TableHead>Reg.nr</TableHead>
                            <TableHead></TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {fetchedChildren && fetchedChildren.length > 0 ? (
                            fetchedChildren.map(child => (
                                <TableRow key={child.id} className='cursor-pointer' onClick={() => navigate(`/bunny/${child.id}`)}>
                                    <TableCell>{child.name}</TableCell>
                                    <TableCell>{child.registration_number ? child.registration_number : 'Ej registrerad'}</TableCell>
                                    <TableCell className='float-right'><ChevronRightIcon /></TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={3} className="text-center">
                                    Kaninen har inga avkommor.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
            )}
        </div>
    )
}

export default BunnyChildren;